import React from "react";
import "./SubBanner.css";
import defaultBanner from "../assets/About-Banner.png";

export default function AboutBanner({ title, subtitle, background }) {
  return (
    <section
      className="cm-hero-section-1"
      style={{ backgroundImage: `url(${background || defaultBanner})` }}
    >
      <div className="cm-hero-overlay-1">
        <div className="cm-hero-content-1">
          {subtitle && <span className="cm-hero-subtitle-1">{subtitle}</span>}
          {title && <h1 className="cm-hero-title-1">{title}</h1>}
        </div>
      </div>
    </section>
  );
}
